import * as React from 'react';
import { Col, Row } from 'react-bootstrap';
import { II18nMessages } from '../../services/branding/models';
import { Redirect, Switch, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { flow } from 'lodash';
import { actions as authActions, IAuthActions } from '../../services/auth/reducer';
import { IAuthState } from '../../services/auth/models';
import { IStore } from '../../redux/IStore';
import ErrorBoundary from '../../components/ErrorBoundary';


interface ICustomerAreaProps {
  i18n: II18nMessages;
  auth: IAuthState;
  actions: {
    auth: IAuthActions;
    push(route: string);
  };
  location: Location;
}

class CustomerAreaNew extends React.Component<ICustomerAreaProps> {
  public componentDidMount() {
    if (process.env.BROWSER) {
      window.scrollTo(0, 0);
    }
  }

  private renderUnauthenticatedRoutes = () => {
    return (
      <Switch>
        <Redirect from="/direct/password/set/:token/:email" to={{
          pathname: '/password/set/:token/:email',
          state: { from: this.props.location }
        }}/>
        <Redirect from="/direct/password/reset/:token/:email" to={{
          pathname: '/password/reset/:token/:email',
          state: { from: this.props.location }
        }}/>
      </Switch>
    );
  }

  public render() {

    return (
      <ErrorBoundary {...this.props}>
        <div className="internal-page-customer-area">
          <div className="container">
            <Row>
              <Col md={12}>
                <div className="customer-area-container">
                  {this.renderUnauthenticatedRoutes()}
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </ErrorBoundary>
    );
  }
}

export default flow([
  connect(
    (state: IStore) => {
      return {
        auth: state.auth,
      };
    },
    (dispatch) => ({
      actions: {
        auth: bindActionCreators({ ...authActions }, dispatch),
        push: bindActionCreators(push, dispatch),
      },
    }),
  ),
  withRouter,
])(CustomerAreaNew);
